
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { BaseIconComponent } from '../../private/base-icon/base-icon.component';

@Component({
  selector: 'icon-date-range',
  imports: [],
  templateUrl: './date-range-icon.component.html',
  styleUrl: '../styles.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateRangeIconComponent extends BaseIconComponent {}
